import { Entry } from 'contentful';
import { NextPageWithLayout } from 'next';
import NextImage from 'next/image';

import { AppDownloadSection } from '../../../components/AppDownloadSection/AppDownloadSection';
import { BlogPostCategoryCard } from '../../../components/Blog/BlogPostCategoryCard/BlogPostCategoryCard';
import { Container } from '../../../components/Container/Container';
import { Heading } from '../../../components/Heading/Heading';
import { MetaTags } from '../../../components/MetaTags/MetaTags';
import { Text } from '../../../components/Text/Text';
import { TypeBlogAuthorSkeleton } from '../../../interfaces/contentful';
import blogHeaderAngler from '../assets/blogHeaderAngler.png';

export interface IBlogAllAuthorsPage {
  blogAuthors?: Entry<TypeBlogAuthorSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>[];
}

const metaTitle = 'Learn how to fish from well known anglers in the community';
const metaDescription =
  'Check out these blog posts by some of our in-house anglers and well known anglers in the community.';

export const BlogAllContributorsPage: NextPageWithLayout<IBlogAllAuthorsPage> = ({
  blogAuthors,
}) => {
  return (
    <div>
      <MetaTags
        link="/blog/authors"
        title={metaTitle}
        description={metaDescription}
        image={blogHeaderAngler.src}
      />
      <Container className="-px-6 sm:-px-11 md:-px-14">
        <div className="relative w-full bg-cover py-8 text-start sm:py-10 md:py-12">
          <NextImage
            alt="most liked catch image"
            className="size-full object-cover"
            src={blogHeaderAngler}
            quality={75}
            fill
            priority
            placeholder="blur"
            sizes="100vw"
          />
          <div className="relative px-6 sm:px-11 md:px-14">
            <Heading as="h1" className="text-sea-foam m-0">
              Explore contributors
            </Heading>
            <Text className="text-sea-foam m-0 w-1/2 md:w-2/3">
              Your guide to fishing, the world’s most popular hobby.
            </Text>
          </div>
        </div>
      </Container>
      <Container className="py-4 sm:py-8">
        <Text className="mb-4 sm:mb-8">
          Want to learn how to land your next PB? With these blog posts our Fishbrain anglers will
          walk you through everything they know to get you catching your next monster.
        </Text>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-6 md:gap-8 lg:grid-cols-3">
          {blogAuthors?.map(author => {
            const { name, authorImage, slug } = author.fields;
            const { id } = author.sys;
            const linkPath = `/blog/authors/${slug}`;
            const cardTitle = name;
            const descriptiveText = `See all our blog posts by ${name}`;
            const imageUrl = authorImage?.fields.file?.url || undefined;
            return slug ? (
              <BlogPostCategoryCard
                linkPath={linkPath}
                cardTitle={cardTitle}
                descriptiveText={descriptiveText}
                imageAlt={name}
                imageUrl={imageUrl}
                key={id}
              />
            ) : (
              <></>
            );
          })}
        </div>
      </Container>

      <AppDownloadSection hasAppRating />
    </div>
  );
};
